export default __webpack_public_path__ + "static/media/list-icon.aa6aefd2.svg";